import { useEffect } from 'react';
import { FaRegBuilding,FaHome, FaSchool, FaBook, FaBlenderPhone } from 'react-icons/fa';
import { RiGalleryLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize.min';
import { SiGoogleclassroom } from "react-icons/si";

const BottomNav = () => {

    useEffect(() => {
        let elems = document.querySelectorAll('.dropdown-trigger.for-nav');
        M.Dropdown.init(elems, 
            { coverTrigger: false, hover: true }
        );
    }, []);

    return ( 
        <nav className="nav main-bg z-depth-0">
            <div className="custom-container">
                <div className="nav-wrapper">
                    {/* dropdowns==== */}
                    {/* <ul id='dropdown1' className='dropdown-content'>
                        <li><Link to="/admission#hta" className="grey-text text-darken-2 is-size-6">How to apply</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/admission#fees-structure" className="grey-text text-darken-2 is-size-6">Fees structure</Link></li>
                    </ul> */}
                    <ul id='dropdown2' className='dropdown-content'>
                        <li><Link to="/portal" className="grey-text text-darken-2 is-size-6">Students Portal</Link></li>
                        <li className="divider"></li>
                        {/* <li><Link to="/sportsAndClubs" className="grey-text text-darken-2 is-size-6">Sports &amp; Clubs</Link></li> */}
                    </ul>
                    <ul id='dropdown4' className='dropdown-content'>
                        <li><Link to="/division/artsAndScience" className="grey-text text-darken-2 is-size-6">Applied Arts &amp; Science</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/division/ccd" className="grey-text text-darken-2 is-size-6">Civil &amp; Construction</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/division/engineering" className="grey-text text-darken-2 is-size-6">Engineering</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/division/commerce" className="grey-text text-darken-2 is-size-6">Commerce</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/division/reed" className="grey-text text-darken-2 is-size-6">Education &amp; Enterprise Dev.</Link></li>
                        <li className="divider"></li>
                        <li><Link to="/shortcourses" className="grey-text text-darken-2 is-size-6">Short &amp; Bridging Courses</Link></li>
                    </ul>
                        {/* dropdowns==== */}

                    <a href="#!" className="sidenav-trigger" data-target="mobile-nav">
                        <i className="material-icons">menu</i>
                    </a>
                    <div className="hide-on-med-and-down nav-list">
                        <Link to="/" className="cont-of-two">
                            <FaHome fontSize="1.3rem" className="mr-2"/>
                            <span>Home</span>
                        </Link>
                        <Link to="/admission" className="cont-of-two">
                            <FaRegBuilding fontSize="1.3rem" className="mr-2"/>
                            <span>Admission</span>                         
                        </Link>
                        <Link to="/about" className="cont-of-two">
                            <FaSchool fontSize="1.3rem" className="mr-2"/>
                            <span>About Us</span>
                        </Link>
                        <a href="#!" className="cont-of-two dropdown-trigger for-nav" data-target="dropdown2">
                            <SiGoogleclassroom fontSize="1.3rem" className="mr-2"/>
                            <span>Students</span>
                        </a>
                        <a href="#!" className="cont-of-two dropdown-trigger for-nav" data-target="dropdown4">
                        <FaBook fontSize="1.3rem" className="mr-2"/>
                            <span>Divisions</span>
                        </a>
                        <Link to="/gallery" className="cont-of-two">
                            <RiGalleryLine fontSize="1.3rem" className="mr-2"/>
                            <span>Gallery</span>
                        </Link>
                        <Link to="/contact" className="cont-of-two">
                            <FaBlenderPhone fontSize="1.3rem" className="mr-2"/>
                            <span>Contact Us</span>
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
     );
}
 
export default BottomNav;